import { callAPI } from "./core";

async function getGlobalReport(startDate, endDate, page, size, query) {
  let params = {
    startDate: startDate.toISOString().split("T")[0],
    endDate: endDate.toISOString().split("T")[0],
    page,
    size,
    query,
  };

  return await callAPI(`/report/global-report`, "GET", params, true);
}

async function getActivityRevenueReport(query, page, size) {
  let params = {
    query,
    page,
    size
  };

  return await callAPI(`/report/activity-report`, "GET", params, true);
}

async function getActivityRevenueGraph(startDate, endDate) {
  let params = {
    startDate: startDate.toISOString().split("T")[0],
    endDate: endDate.toISOString().split("T")[0]
  };

  return await callAPI(`/report/activity-revenue-graph`, "GET", params, true);
}

async function getBillingRevenueReport(query, startDate, endDate) {
  let params = {
    query,
    startDate: startDate.toISOString().split("T")[0],
    endDate: endDate.toISOString().split("T")[0]
  };

  return await callAPI(`/report/billing-report`, "GET", params, true);
}

async function getBillingRevenueGraph(startDate, endDate) {
  let params = {
    startDate: startDate.toISOString().split("T")[0],
    endDate: endDate.toISOString().split("T")[0]
  };

  return await callAPI(`/report/billing-revenue-graph`, "GET", params, true);
}

async function getSubscriptionMMR() {
  return await callAPI(`/report/subscription-mmr`, "GET", null, true);
}

export {
  getGlobalReport,
  getActivityRevenueReport,
  getActivityRevenueGraph,
  getBillingRevenueReport,
  getBillingRevenueGraph,
  getSubscriptionMMR,
};
